export default __webpack_public_path__ + "static/investment-image-2-b8f858f4ebb1b1e99514905d5bdfed66.jpg";